import React, { useState, useEffect } from 'react';
import { Menu, Spin, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFeaturePermissions, setSideMenuItems } from 'src/reducers/permissionsReducer';
import apiCalls from 'src/api/apiCalls';
const SideNavBar = ({handleSelectedMenu}) => {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const adminDetails = useSelector((state) => state.oidc?.adminDetails);
  const [selectedKey, setSelectedKey] = useState('');
  let path = window.location.pathname?.split('/')[1];
  const menuList = useSelector((store)=> store?.permissions?.menuItems);
  const _defaultPaths={"customer" : "customers","transactions":"transactions","cases":"cases"}
  useEffect(() => {
    fetchMenuItems();
  }, [adminDetails?.id]);
  useEffect(()=>{
   if(menuList){
    if(path === 'caseView'){
      path = 'Cases';
    }
    const defaultItem = menuList?.find((item) => item?.isEnabled && item.screenName?.toLowerCase()===_defaultPaths[path?.toLowerCase()]);
    if (defaultItem) {
      setSelectedKey(defaultItem?.id); // Assuming you want to set the ID of the matched item as the selected key
    }
   }
  },[path])
  const fetchMenuItems = async () => {
    setLoading(true);
    try {
      let response = await apiCalls.getMenuLink(adminDetails?.id);
      dispatch(setSideMenuItems(response.data));
      dispatch(fetchFeaturePermissions(response.data[0]?.screenName, response.data[0]?.id))
      if (response?.data?.length > 0) {
        const groupedItems = response.data
          .filter((item) => item.isEnabled)
          .reduce((acc, item) => {
            const { parentId } = item;
            if (!parentId) {
              acc[item.id] = { ...item, subItems: [] };  // If no parent, add as a parent
            } else {
              if (!acc[parentId]) {
                acc[parentId] = { subItems: [] };  // Ensure the parent exists
              }
              acc[parentId].subItems.push(item);  // Add as a subItem to parent
            }
            return acc;
          }, {});
        setMenuItems(Object.values(groupedItems));
        const defaultItem = response.data?.find((item) => item?.isEnabled);
        if (defaultItem) {
          setSelectedKey(defaultItem?.id); // Assuming you want to set the ID of the matched item as the selected key
        }
      } else {
        console.log(apiCalls.isErrorDispaly(response));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const handleMenu = ({ key }) => {
    const _item = menuItems
      .flatMap((item) => [
        { ...item, subItems: item.subItems || [] },
        ...(item.subItems || []).map((sub) => ({ ...sub })),
      ])
      .find((item) => item.id === key);
    const route = _item?.path;
    setSelectedKey(_item?.id);
    if (route) {
      navigate(route);
    }
    dispatch(fetchFeaturePermissions(_item?.screenName, _item?.id))   
    handleSelectedMenu();   
  };
  return (
    <div className='lg:w-[90px] lg:fixed  border-r border-r-light-secondaryColor dark:border-r-dark-secondaryColor'>
      <div className='fixed top-0 w-[89px] z-10 bg-light-layoutBg dark:bg-dark-layoutBg hidden lg:block'>
     <img className='dark-customlogo pt-[5px] mx-auto w-16' src={process.env.REACT_APP_LOGO_URL_DARK} alt='DigitalBank' />
     <img className='light-customlogo pt-[5px] mx-auto w-16' src={process.env.REACT_APP_LOGO_URL_LIGHT} alt='DigitalBank' />
      <hr className='text-light-secondaryColor block dark:text-dark-secondaryColor mt-[6px] '/>
      </div>
      {loading ? (
        <Spin size="large" />
      ) : (
        <Menu
          mode="vertical"
          selectedKeys={[selectedKey]}
          theme="dark"
          className="bg-light-layoutBg h-screen overflow-auto pt-3 lg:pt-[55px] dark:bg-dark-layoutBg max-lg:h-screen max-lg:overflow-auto font-sans custome-header border-r border-r-light-secondaryColor dark:border-r-dark-secondaryColor"
        >
          {menuItems.map((item) => (
            <div onClick={() => handleMenu({ key: item.id })} key={item.id}>
              <Tooltip title={item.screenName} placement="right">
                <Menu.Item
                 className={`${item.id === selectedKey ? "active-menu":""}`}
                  key={item.id}
                  icon={<span className={`${item.className}`}></span>}
                >
                  <span>{item.screenName}</span>
                </Menu.Item>
              </Tooltip>
            </div>
          ))}
        </Menu>
      )}
    </div>
  );
};
export default SideNavBar;
